import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from 'environments/environment';
import { enableProdMode } from '@angular/core';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';

const workerPath = (() => {
  try {
    return new URL('./assets/pdf.worker.min.mjs', import.meta.url).href;
  } catch (e) {
    return '/assets/pdf.worker.min.mjs';
  }
})();
GlobalWorkerOptions.workerSrc = workerPath;
// set workerSrc on possible namespace objects used by different builds
if ((pdfjsLib as any).GlobalWorkerOptions) {
  (pdfjsLib as any).GlobalWorkerOptions.workerSrc = workerPath;
}

// Runtime diagnostic: print base API URL used by the app
try {
  console.debug('environment.apiUrl =', environment.apiUrl);
} catch (e) {
  // ignore
}

// --- 核心攔截邏輯：在 Angular 啟動前備份原始 Token ---
(function() {
  const currentUrl = window.location.href;
  if (currentUrl.includes('token=')) {
    // 1. 強制存入 sessionStorage，防止頁面跳轉導致資料遺失
    sessionStorage.setItem('RAW_TOKEN_URL_BACKUP', currentUrl);
    
    // 2. 使用最顯眼的樣式印出，方便你在 Console 檢查
    console.log(
      '%c 🛡️ 捕捉到原始 Token 網址:', 
      'background: #000; color: #00FF00; font-size: 16px; font-weight: bold; padding: 10px; border: 3px solid #00FF00;', 
      currentUrl
    );
  }
})();

if (environment.production) {
  enableProdMode();
}
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
